import { useState } from 'react'
import { Button } from '../components/ui/Button'
import { Input } from '../components/ui/Input'
import { Select } from '../components/ui/Select'
import { Stepper } from '../components/ui/Stepper'
import { Navbar } from '../components/layout/Navbar'

export const ComponentExamplePage = () => {
  const [showPassword1, setShowPassword1] = useState(false)
  const [showPassword2, setShowPassword2] = useState(false)
  const [showPassword3, setShowPassword3] = useState(false)
  const [showPassword4, setShowPassword4] = useState(false)
  const [showPassword5, setShowPassword5] = useState(false)

  const selectOptions = [
    { value: 'option1', label: 'Opción 1' },
    { value: 'option2', label: 'Opción 2' },
    { value: 'option3', label: 'Opción 3' },
  ]

  const stepperSteps = [
    {
      id: '1',
      title: 'Paso 1',
      description: 'Información personal',
      status: 'completed' as const,
    },
    {
      id: '2',
      title: 'Paso 2',
      description: 'Documentos',
      status: 'completed' as const,
    },
    {
      id: '3',
      title: 'Paso 3',
      description: 'Validación',
      status: 'current' as const,
    },
    {
      id: '4',
      title: 'Paso 4',
      description: 'Revisión',
      status: 'pending' as const,
    },
    {
      id: '5',
      title: 'Paso 5',
      description: 'Finalización',
      status: 'pending' as const,
    },
    {
      id: '6',
      title: 'Paso 6',
      description: 'Confirmación',
      status: 'pending' as const,
    },
  ]
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <div className="flex-1 p-8 bg-gray-50">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">
            Design System - Componentes OLR
          </h1>

          {/* Buttons Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
              Botones
            </h2>

            <div className="space-y-8">
              {/* Primary Buttons */}
              <div>
                <h3 className="text-lg font-medium text-gray-700 mb-4">
                  Primary
                </h3>
                <div className="flex flex-wrap gap-4">
                  <Button variant="primary">Button CTA</Button>
                  <Button variant="primary" disabled>
                    Button CTA Disabled
                  </Button>
                  <Button variant="primary" isLoading>
                    Button CTA Loading
                  </Button>
                </div>
              </div>

              {/* Secondary Buttons */}
              <div>
                <h3 className="text-lg font-medium text-gray-700 mb-4">
                  Secondary
                </h3>
                <div className="flex flex-wrap gap-4">
                  <Button variant="secondary">Button CTA</Button>
                  <Button variant="secondary" disabled>
                    Button CTA Disabled
                  </Button>
                  <Button variant="secondary" isLoading>
                    Button CTA Loading
                  </Button>
                </div>
              </div>

              {/* Sizes */}
              <div>
                <h3 className="text-lg font-medium text-gray-700 mb-4">
                  Tamaños
                </h3>
                <div className="flex flex-wrap items-center gap-4">
                  <Button variant="primary" size="sm">
                    Small
                  </Button>
                  <Button variant="primary" size="default">
                    Default
                  </Button>
                  <Button variant="primary" size="lg">
                    Large
                  </Button>
                </div>
              </div>
            </div>
          </section>

          {/* Colors Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
              Paleta de Colores - Figma
            </h2>

            {/* Brand Colors */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-700 mb-4">
                Colores de Marca
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div className="bg-olr-primary h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-sm text-center">
                    #1789CF
                    <br />
                    Primary
                  </span>
                </div>
                <div className="bg-olr-secondary h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-sm text-center">
                    #58A0D2
                    <br />
                    Secondary
                  </span>
                </div>
                <div className="bg-olr-tertiary h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-sm text-center">
                    #19D8E6
                    <br />
                    Tertiary
                  </span>
                </div>
                <div className="bg-olr-quaternary h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-sm text-center">
                    #407291
                    <br />
                    Quaternary
                  </span>
                </div>
              </div>
            </div>

            {/* State Colors */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-700 mb-4">
                Colores de Estado
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                <div className="bg-olr-success h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-sm text-center">
                    #119E16
                    <br />
                    Success
                  </span>
                </div>
                <div className="bg-olr-danger h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-sm text-center">
                    #DD2424
                    <br />
                    Danger
                  </span>
                </div>
                <div className="bg-olr-warning h-20 rounded-lg flex items-center justify-center">
                  <span className="text-black font-medium text-sm text-center">
                    #FFB854
                    <br />
                    Warning
                  </span>
                </div>
                <div className="bg-olr-info h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-sm text-center">
                    #19D8E6
                    <br />
                    Info
                  </span>
                </div>
                <div className="bg-olr-complementary h-20 rounded-lg flex items-center justify-center">
                  <span className="text-black font-medium text-sm text-center">
                    #C5E700
                    <br />
                    Complementary
                  </span>
                </div>
              </div>
            </div>

            {/* Neutrals */}
            <div className="mb-8">
              <h3 className="text-lg font-medium text-gray-700 mb-4">
                Colores Neutros
              </h3>
              <div className="grid grid-cols-3 md:grid-cols-7 gap-4">
                <div className="bg-olr-white h-20 rounded-lg flex items-center justify-center border border-gray-200">
                  <span className="text-black font-medium text-xs">White</span>
                </div>
                <div className="bg-olr-grey-1 h-20 rounded-lg flex items-center justify-center">
                  <span className="text-black font-medium text-xs">Grey 1</span>
                </div>
                <div className="bg-olr-grey-2 h-20 rounded-lg flex items-center justify-center">
                  <span className="text-black font-medium text-xs">Grey 2</span>
                </div>
                <div className="bg-olr-grey-3 h-20 rounded-lg flex items-center justify-center">
                  <span className="text-black font-medium text-xs">Grey 3</span>
                </div>
                <div className="bg-olr-grey-4 h-20 rounded-lg flex items-center justify-center">
                  <span className="text-black font-medium text-xs">Grey 4</span>
                </div>
                <div className="bg-olr-grey-5 h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-xs">Grey 5</span>
                </div>
                <div className="bg-olr-body h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-xs">Body</span>
                </div>
                <div className="bg-olr-dark h-20 rounded-lg flex items-center justify-center">
                  <span className="text-white font-medium text-xs">Dark</span>
                </div>
              </div>
            </div>

            {/* Gradient */}
            <div>
              <h3 className="text-lg font-medium text-gray-700 mb-4">
                Gradiente
              </h3>
              <div
                className="h-20 rounded-lg flex items-center justify-center text-white font-medium"
                style={{
                  background:
                    'linear-gradient(180deg, #1789CF 0%, #02298A 84.79%, #021B79 100%)',
                }}
              >
                OLR Primary Gradient
              </div>
            </div>
          </section>

          {/* Typography Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
              Tipografía - Figma
            </h2>

            <div className="space-y-6">
              {/* Headlines */}
              <div className="border-b border-gray-200 pb-6">
                <h3 className="text-lg font-medium text-gray-700 mb-4">
                  Headlines
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="text-display text-olr-dark mb-2">
                      Display 1
                    </div>
                    <p className="text-sm text-gray-600">
                      Bold, 72px - text-display
                    </p>
                  </div>

                  <div>
                    <div className="text-h1 text-olr-dark mb-2">Heading 1</div>
                    <p className="text-sm text-gray-600">
                      Bold, 56px - text-h1
                    </p>
                  </div>

                  <div>
                    <div className="text-h2 text-olr-dark mb-2">Heading 2</div>
                    <p className="text-sm text-gray-600">
                      Bold, 48px - text-h2
                    </p>
                  </div>

                  <div>
                    <div className="text-h3 text-olr-dark mb-2">Heading 3</div>
                    <p className="text-sm text-gray-600">
                      Bold, 32px - text-h3
                    </p>
                  </div>

                  <div>
                    <div className="text-h4 text-olr-dark mb-2">Heading 4</div>
                    <p className="text-sm text-gray-600">
                      Bold, 24px - text-h4
                    </p>
                  </div>

                  <div>
                    <div className="text-h4-uppercase text-olr-dark mb-2">
                      HEADING 4 UPPERCASE
                    </div>
                    <p className="text-sm text-gray-600">
                      Bold, 24px - text-h4-uppercase
                    </p>
                  </div>
                </div>
              </div>

              {/* Paragraphs */}
              <div className="border-b border-gray-200 pb-6">
                <h3 className="text-lg font-medium text-gray-700 mb-4">
                  Paragraph
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="text-paragraph-1 text-olr-body mb-2">
                      Paragraph 1
                    </div>
                    <p className="text-sm text-gray-600">
                      Regular, 18px - text-paragraph-1
                    </p>
                  </div>

                  <div>
                    <div className="text-paragraph-2 text-olr-body mb-2">
                      Paragraph 2
                    </div>
                    <p className="text-sm text-gray-600">
                      Regular, 16px - text-paragraph-2
                    </p>
                  </div>
                </div>
              </div>

              {/* Interactive Elements */}
              <div>
                <h3 className="text-lg font-medium text-gray-700 mb-4">
                  Button / Link
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="text-button text-olr-dark mb-2">Button</div>
                    <p className="text-sm text-gray-600">
                      Semibold, 18px - text-button
                    </p>
                  </div>

                  <div>
                    <div className="text-hyperlink text-olr-primary mb-2">
                      Hyperlink
                    </div>
                    <p className="text-sm text-gray-600">
                      SemiBold, 14px - text-hyperlink
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Inputs Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
              Inputs
            </h2>

            <div className="space-y-8">
              {/* Con Label */}
              <div>
                <h3 className="text-lg font-medium text-gray-700 mb-4">
                  Con Label
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <h4 className="text-sm font-medium text-gray-600">
                      Estados
                    </h4>
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="email"
                    />
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="email"
                      className="border-gray-400"
                    />
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="email"
                      className="border-blue-500 ring-2 ring-blue-500"
                    />
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="email"
                      disabled
                    />
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="email"
                      error="Mensaje de error."
                    />
                  </div>
                  <div className="space-y-4">
                    <h4 className="text-sm font-medium text-gray-600">
                      Con Password
                    </h4>
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="password"
                      showPassword={showPassword1}
                      onTogglePassword={() => setShowPassword1(!showPassword1)}
                    />
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="password"
                      showPassword={showPassword2}
                      onTogglePassword={() => setShowPassword2(!showPassword2)}
                    />
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="password"
                      showPassword={showPassword3}
                      onTogglePassword={() => setShowPassword3(!showPassword3)}
                      className="border-blue-500 ring-2 ring-blue-500"
                    />
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="password"
                      showPassword={showPassword4}
                      onTogglePassword={() => setShowPassword4(!showPassword4)}
                      disabled
                    />
                    <Input
                      label="Correo electrónico"
                      placeholder="Escribe aquí"
                      type="password"
                      showPassword={showPassword5}
                      onTogglePassword={() => setShowPassword5(!showPassword5)}
                      error="Mensaje de error."
                    />
                  </div>
                </div>
              </div>

              {/* Sin Label */}
              <div>
                <h3 className="text-lg font-medium text-gray-700 mb-4">
                  Sin Label
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="space-y-4">
                    <Input placeholder="Escribe aquí" />
                    <Input
                      placeholder="Escribe aquí"
                      className="border-gray-400"
                    />
                    <Input
                      placeholder="Escribe aquí"
                      className="border-blue-500 ring-2 ring-blue-500"
                    />
                    <Input placeholder="Escribe aquí" disabled />
                    <Input
                      placeholder="Escribe aquí"
                      error="Mensaje de error."
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Selects Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
              Selects
            </h2>

            <div className="space-y-6">
              <div className="max-w-md">
                <Select
                  label="Label"
                  options={selectOptions}
                  placeholder="Selecciona"
                />
              </div>
              <div className="max-w-md">
                <Select
                  label="Label"
                  options={selectOptions}
                  placeholder="Selecciona"
                />
              </div>
              <div className="max-w-md">
                <Select
                  label="Label"
                  options={selectOptions}
                  placeholder="Selecciona"
                />
              </div>
              <div className="max-w-md">
                <Select
                  label="Label"
                  options={selectOptions}
                  placeholder="Selecciona"
                  disabled
                />
              </div>
            </div>
          </section>

          {/* Stepper Section */}
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
              Stepper
            </h2>

            <div className="space-y-12">
              {/* Desktop Stepper */}
              <div>
                <h3 className="text-lg font-medium text-gray-700 mb-6">
                  Desktop
                </h3>
                <div className="bg-white p-8 rounded-lg border">
                  <Stepper
                    steps={stepperSteps}
                    variant="desktop"
                    orientation="horizontal"
                  />
                </div>
              </div>

              {/* Mobile Stepper */}
              <div>
                <h3 className="text-lg font-medium text-gray-700 mb-6">
                  Mobile
                </h3>
                <div className="bg-white p-8 rounded-lg border max-w-md">
                  <Stepper steps={stepperSteps} variant="mobile" />
                </div>
              </div>
            </div>
          </section>

          {/* Interactive Examples */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-800 mb-6">
              Ejemplos Interactivos
            </h2>

            <div className="space-y-4">
              <Button
                variant="primary"
                onClick={() => alert('¡Botón primario clickeado!')}
              >
                Entrar
              </Button>

              <Button
                variant="secondary"
                onClick={() => alert('¡Botón secundario clickeado!')}
              >
                Cancelar
              </Button>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}
